import {createFromMarkup} from './utils';

export default class Editable {
  constructor(element, onEdit) {
    this.editable = element;
    this.editing = null;
    this.onEdit = onEdit;

    this.listeners = {
      onEditableClick: (evt) => this._onClick(evt),
      onEditableSubmit: (evt) => this._onSubmit(evt),
      onEditableCancel: (evt) => this._onCancel(evt)
    };

    this.editable.addEventListener('click', this.listeners.onEditableClick);
  }

  destroy() {
    this.editable.removeEventListener('click', this.listeners.onEditableClick);

    if (this.editing) {
      this._removeEditing();
    }
  }

  _onClick(evt) {
    evt.stopPropagation();
    this.editing = createFromMarkup(this._getMarkup(evt.target.innerText));
    this.editable.parentNode.replaceChild(this.editing, this.editable);

    this.editing.querySelector('[data-action="cancel"]').addEventListener('click', this.listeners.onEditableCancel);
    this.editing.querySelector('[data-action="submit"]').addEventListener('click', this.listeners.onEditableSubmit);

  }

  _onSubmit() {
    const oldText = this.editable.innerText;
    const newText = this.editing.querySelector('input').value;
    if (newText && oldText !== newText) {
      this.editable.innerText = newText;
      this.editing.parentNode.replaceChild(this.editable, this.editing);
      this._removeEditing();
      if (this.onEdit) {
        this.onEdit();
      }
    } else {
      this._onCancel();
    }
  }

  _onCancel() {
    if (this.editing) {
      this.editing.parentNode.replaceChild(this.editable, this.editing);
      this._removeEditing();
    }
  }

  _removeEditing() {
    this.editing.querySelector('[data-action="cancel"]').removeEventListener('click', this.listeners.onEditableCancel);
    this.editing.querySelector('[data-action="submit"]').removeEventListener('click', this.listeners.onEditableSubmit);

    this.editing = null;
  }

  _getMarkup(text) {
    return `<div class="editing">
      <div class="inline-field">
        <input value="${text}"/>
      </div>
      <div class="inline-buttons">
          <button class="btn-icon" data-action="cancel"><i class="icon icon-cross"></i></button>
          <button class="btn-icon" data-action="submit"><i class="icon icon-check"></i></button>
      </div>
    </div>`;
  }
}
